<template>
  <v-container fluid class="pa-8">
    <v-row>
      <v-col v-for="(stat, index) in stats" :key="index" cols="12" sm="6" md="4" lg="2">
        <v-card class="rounded-lg elevation-0" :color="stat.bgColor" height="100%">
          <v-card-text class="text-center py-6">
            <div class="d-flex justify-center mb-3">
              <v-avatar color="transparent" size="48">
                <v-icon :color="stat.iconColor" >{{ stat.icon }}</v-icon>
              </v-avatar>
            </div>
            <div :class="`mb-1 ${stat.textColor}`" style="font-family: 'Poppins', sans-serif !important;"><b>{{ stat.title }}</b></div>
            <div :class="`text-h5 ${stat.textColor}`" style="font-family: 'Poppins', sans-serif !important;">{{ stat.value }}</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row style="font-family: 'Poppins', sans-serif !important;">
      <!-- Panel izquierdo - Gráfico de barras y datos de ingresos -->
      <v-col cols="12" md="8">
        <v-card class="pa-6 shadowCard" style="font-family: 'Poppins', sans-serif !important;">
          <div class="d-flex justify-space-between align-center mb-4">
            <div>
              <h2 class="text-h5 mb-1" style="font-family: 'Poppins', sans-serif !important;">Revenue Updates</h2>
              <p class="text-subtitle-1 text-medium-emphasis" style="font-family: 'Poppins', sans-serif !important;">Overview of Profit</p>
            </div>
            <v-select
              v-model="selectedMonth"
              :items="months"
              outlined
              dense
              class="month-selector"
              hide-details
              style="max-width: 150px;"
            ></v-select>
          </div>

          <div class="d-flex flex-column flex-md-row">
            <div class="chart-container flex-grow-1">
              <apexchart
                type="rangeBar"
                height="300"
                :options="chartOptions"
                :series="series"
              ></apexchart>
            </div>
            
            <div class="stats-container ml-md-6 mt-6 mt-md-0">
              <div class="d-flex align-center mb-2">
                <v-icon color="blue lighten-1" class="mr-2">mdi-view-grid</v-icon>
                <h3 class="text-h4" style="font-family: 'Poppins', sans-serif !important;">$63,489.50</h3>
              </div>
              <p class="text-subtitle-1 text-medium-emphasis mb-6">Total Earnings</p>
              
              <div class="mb-6">
                <div class="d-flex align-center mb-1">
                  <v-icon small color="blue" class="mr-2">mdi-circle</v-icon>
                  <span class="text-subtitle-1">Earnings this month</span>
                </div>
                <h3 class="text-h5 ml-6" style="font-family: 'Poppins', sans-serif !important;">$48,820</h3>
              </div>
              
              <div class="mb-6">
                <div class="d-flex align-center mb-1">
                  <v-icon small color="light-blue lighten-2" class="mr-2">mdi-circle</v-icon>
                  <span class="text-subtitle-1">Expense this month</span>
                </div>
                <h3 class="text-h5 ml-6" style="font-family: 'Poppins', sans-serif !important;">$26,498</h3>
              </div>
              
              <v-btn
                color="blue lighten-1"
                class="text-capitalize white--text rounded-lg px-6"
                elevation="1"
              >
                View Full Report
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-col>
      
      <!-- Panel derecho - Estadísticas e indicadores -->
      <v-col cols="12" md="4">
        <v-card class="pa-6 mb-6 shadowCard">
          <h2 class="text-h5 mb-6" style="font-family: 'Poppins', sans-serif !important;">Yearly Breakup</h2>
          
          <div class="d-flex justify-space-between align-center">
            <div>
              <h3 class="text-h4 mb-2" style="font-family: 'Poppins', sans-serif !important;">$36,358</h3>
              <div class="d-flex align-center">
                <v-icon small color="green" class="mr-1">mdi-arrow-up</v-icon>
                <span class="success--text font-weight-medium" style="font-family: 'Poppins', sans-serif !important;">+9%</span>
                <span class="text-subtitle-2 text-medium-emphasis ml-2" style="font-family: 'Poppins', sans-serif !important;">last year</span>
              </div>
            </div>
            
            <div class="progress-circle">
              <apexchart
                type="radialBar"
                height="150"
                :options="radialChartOptions"
                :series="[75]"
              ></apexchart>
            </div>
          </div>
          
          <div class="d-flex mt-3">
            <div class="d-flex align-center mr-4">
              <v-icon small color="blue" class="mr-1">mdi-circle</v-icon>
              <span class="text-body-2">2024</span>
            </div>
            <div class="d-flex align-center">
              <v-icon small color="grey lighten-1" class="mr-1">mdi-circle</v-icon>
              <span class="text-body-2 text-medium-emphasis">2024</span>
            </div>
          </div>
        </v-card>
        
        <v-card class="pa-6 shadowCard">
          <h2 class="text-h5 mb-6">Monthly Earnings</h2>
          
          <div class="d-flex justify-space-between align-center mb-4">
            <div>
              <h3 class="text-h4 mb-2">$6,820</h3>
              <div class="d-flex align-center">
                <v-icon small color="red" class="mr-1">mdi-arrow-down</v-icon>
                <span class="error--text font-weight-medium">+9%</span>
                <span class="text-subtitle-2 text-medium-emphasis ml-2">last year</span>
              </div>
            </div>
            
            <v-avatar color="light-blue" size="60">
              <v-icon dark size="30">mdi-currency-usd</v-icon>
            </v-avatar>
          </div>
          
          <div class="wave-chart">
            <apexchart
              type="line"
              height="80"
              :options="waveChartOptions"
              :series="waveSeries"
            ></apexchart>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <!-- Panel izquierdo - Estadísticas semanales -->
      <v-col cols="12" md="5">
        <v-card  class="pa-6 shadowCard">
          <div class="text-h5 mb-1" style="font-family: 'Poppins', sans-serif !important;">Weekly Stats</div>
          <p class="text-subtitle-1 text-medium-emphasis mb-6" style="font-family: 'Poppins', sans-serif !important;">Average sales</p>
          
          <!-- Gráfico de línea -->
          <div class="chart-container mb-6">
            <canvas ref="salesChart" height="120"></canvas>
          </div>
          
          <!-- Estadísticas con iconos -->
          <div class="stats-list">
            <v-card class="mb-4 py-3 px-4" flat>
              <div class="d-flex align-center justify-space-between">
                <div class="d-flex align-center">
                  <div class="mr-4 blue lighten-4 rounded pa-2">
                    <v-icon color="blue">mdi-view-grid</v-icon>
                  </div>
                  <div>
                    <div class="font-weight-bold" style="font-family: 'Poppins', sans-serif !important;">Top Sales</div>
                    <div class="text-subtitle-2 text-medium-emphasis" style="font-family: 'Poppins', sans-serif !important;">Johnathan Doe</div>
                  </div>
                </div>
                <div class="blue--text text--lighten-1 font-weight-medium" style="font-family: 'Poppins', sans-serif !important;">+68</div>
              </div>
            </v-card>
            
            <v-card class="mb-4 py-3 px-4" flat>
              <div class="d-flex align-center justify-space-between">
                <div class="d-flex align-center">
                  <div class="mr-4 teal lighten-5 rounded pa-2">
                    <v-icon color="teal lighten-2">mdi-star</v-icon>
                  </div>
                  <div>
                    <div class="font-weight-bold" style="font-family: 'Poppins', sans-serif !important;">Best Seller</div>
                    <div class="text-subtitle-2 text-medium-emphasis" style="font-family: 'Poppins', sans-serif !important;">Footware</div>
                  </div>
                </div>
                <div class="teal--text text--lighten-3 font-weight-medium" style="font-family: 'Poppins', sans-serif !important;">+45</div>
              </div>
            </v-card>
            
            <v-card class="py-3 px-4" flat>
              <div class="d-flex align-center justify-space-between">
                <div class="d-flex align-center">
                  <div class="mr-4 red lighten-5 rounded pa-2">
                    <v-icon color="red lighten-2">mdi-message-text</v-icon>
                  </div>
                  <div>
                    <div class="font-weight-bold">Most Commented</div>
                    <div class="text-subtitle-2 text-medium-emphasis">Fashionware</div>
                  </div>
                </div>
                <div class="red--text text--lighten-2 font-weight-medium">+14</div>
              </div>
            </v-card>
          </div>
        </v-card>
      </v-col>
      
      <!-- Panel derecho - Proyectos principales -->
      <v-col cols="12" md="7">
        <v-card  class="pa-6 shadowCard">
          <div class="d-flex justify-space-between align-center mb-4">
            <div>
              <h2 class="text-h5 mb-1" style="font-family: 'Poppins', sans-serif !important;">Top Projects</h2>
              <p class="text-subtitle-1 text-medium-emphasis" style="font-family: 'Poppins', sans-serif !important;">Best Products</p>
            </div>
            <v-select
              v-model="selectedMonth"
              :items="months"
              outlined
              dense
              class="month-selector"
              hide-details
              style="max-width: 150px;"
            ></v-select>
          </div>
          
          <v-data-table
            :headers="headers"
            :items="projects"
            :items-per-page="4"
            hide-default-footer
            class="elevation-0"
          >
            <template v-slot:item.assigned="{ item }">
              <div class="d-flex align-center">
                <v-avatar size="40" class="mr-3">
                  <v-img :src="item.avatar"></v-img>
                </v-avatar>
                <div>
                  <div class="font-weight-medium">{{ item.name }}</div>
                  <div class="text-caption text-medium-emphasis">{{ item.role }}</div>
                </div>
              </div>
            </template>
            
            <template v-slot:item.priority="{ item }">
              <v-chip
                small
                :color="getPriorityColor(item.priority)"
                text-color="white"
                class="px-2"
                :class="getPriorityTextColor(item.priority)"
              >
                {{ item.priority }}
              </v-chip>
            </template>
            
            <template v-slot:item.budget="{ item }">
              <span class="font-weight-medium">{{ item.budget }}</span>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  // Componente para el gráfico de línea
  const SalesLineChart = {
    template: '<canvas ref="canvas" height="120"></canvas>',
    mounted() {
      this.renderChart();
    },
    methods: {
      renderChart() {
        const ctx = this.$refs.canvas.getContext('2d');
        
        // Asegúrate de tener Chart.js instalado: npm install chart.js
        const Chart = require('chart.js');
        
        new Chart(ctx, {
          type: 'line',
          data: {
            labels: ['', '', '', '', '', '', '', '', '', '', '', ''],
            datasets: [{
              data: [10, 30, 85, 49, 30, 35, 55, 80, 45, 20, 55, 30],
              backgroundColor: 'rgba(93, 120, 255, 0.15)',
              borderColor: 'rgba(93, 120, 255, 1)',
              borderWidth: 2,
              pointRadius: 0,
              fill: true
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false
            },
            tooltips: {
              enabled: false
            },
            scales: {
              xAxes: [{
                display: false
              }],
              yAxes: [{
                display: false
              }]
            },
            elements: {
              line: {
                tension: 0.4 // Suavizado de la línea
              }
            }
          }
        });
      }
    }
  };

  // import ApexCharts from 'apexcharts'

  export default {


    name: 'StatsDashboard',
    data() {
      return {

        headers: [
          { text: 'Assigned', value: 'assigned', sortable: false },
          { text: 'Project', value: 'project' },
          { text: 'Priority', value: 'priority' },
          { text: 'Budget', value: 'budget' }
        ],
        projects: [
          {
            name: 'Sunil Joshi',
            role: 'Web Designer',
            avatar: 'https://via.placeholder.com/40',
            project: 'Elite Admin',
            priority: 'Low',
            budget: '$3.9K'
          },
          {
            name: 'John Deo',
            role: 'Web Developer',
            avatar: 'https://via.placeholder.com/40',
            project: 'Flexy Admin',
            priority: 'Medium',
            budget: '$24.5K'
          },
          {
            name: 'Nirav Joshi',
            role: 'Web Manager',
            avatar: 'https://via.placeholder.com/40',
            project: 'Material Pro',
            priority: 'High',
            budget: '$12.8K'
          },
          {
            name: 'Yuvraj Sheth',
            role: 'Project Manager',
            avatar: 'https://via.placeholder.com/40',
            project: 'Xtreme Admin',
            priority: 'Very High',
            budget: '$2.4K'
          }
        ],

        stats: [
          {
            title: 'Employees',
            value: '96',
            icon: 'mdi-account-group',
            bgColor: 'blue lighten-5',
            iconColor: 'blue darken-1',
            textColor: 'blue--text'
          },
          {
            title: 'Clients',
            value: '3,650',
            icon: 'mdi-briefcase',
            bgColor: 'amber lighten-5',
            iconColor: 'amber darken-1',
            textColor: 'amber--text text--darken-3'
          },
          {
            title: 'Projects',
            value: '356',
            icon: 'mdi-file-document-multiple',
            bgColor: 'cyan lighten-5',
            iconColor: 'cyan darken-1',
            textColor: 'cyan--text'
          },
          {
            title: 'Events',
            value: '696',
            icon: 'mdi-calendar-star',
            bgColor: 'pink lighten-5',
            iconColor: 'red',
            textColor: 'pink--text text--lighten-1'
          },
          {
            title: 'Payroll',
            value: '$96k',
            icon: 'mdi-currency-usd',
            bgColor: 'green lighten-5',
            iconColor: 'green',
            textColor: 'green--text text--accent-4'
          },
          {
            title: 'Reports',
            value: '59',
            icon: 'mdi-chart-bar',
            bgColor: 'purple lighten-5',
            iconColor: 'purple',
            textColor: 'purple--text'
          }
        ],

        selectedMonth: 'March 2024',
        months: ['January 2024', 'February 2024', 'March 2024', 'April 2024'],
        
        // Datos para el gráfico de barras
        series: [
            {
              data: [
                {
                  x: '2008',
                  y: [2800, 4500]
                },
                {
                  x: '2009',
                  y: [3200, 4100]
                },
                {
                  x: '2010',
                  y: [2950, 7800]
                },
                {
                  x: '2011',
                  y: [3000, 4600]
                },
                {
                  x: '2012',
                  y: [3500, 4100]
                },
                {
                  x: '2013',
                  y: [4500, 6500]
                },
                {
                  x: '2014',
                  y: [4100, 5600]
                }
              ]
            }
          ],
          chartOptions: {
            chart: {
              height: 350,
              type: 'rangeBar',
              zoom: {
                enabled: false
              }
            },
            plotOptions: {
              bar: {
                isDumbbell: true,
                columnWidth: 3,
                dumbbellColors: [['#008FFB', '#00E396']]
              }
            },
            legend: {
              show: true,
              showForSingleSeries: true,
              position: 'top',
              horizontalAlign: 'left',
              customLegendItems: ['Product A', 'Product B']
            },
            fill: {
              type: 'gradient',
              gradient: {
                type: 'vertical',
                gradientToColors: ['#00E396'],
                inverseColors: true,
                stops: [0, 100]
              }
            },
            grid: {
              xaxis: {
                lines: {
                  show: true
                }
              },
              yaxis: {
                lines: {
                  show: false
                }
              }
            },
            xaxis: {
              tickPlacement: 'on'
            }
          },
        
        // Datos para el gráfico radial
        radialChartOptions: {
          chart: {
            type: 'radialBar',
          },
          plotOptions: {
            radialBar: {
              hollow: {
                size: '60%',
              },
              dataLabels: {
                showOn: "always",
                name: {
                  show: false,
                },
                value: {
                  show: false,
                }
              },
              track: {
                background: '#E0E0FF',
              }
            },
          },
          colors: ['#4285F4'],
          stroke: {
            lineCap: 'round'
          },
        },
        
        // Datos para el gráfico de ondas
        waveSeries: [{
          name: "Monthly Trend",
          data: [25, 45, 30, 20, 40, 25, 50]
        }],
        waveChartOptions: {
          chart: {
            type: 'line',
            sparkline: {
              enabled: true
            },
            toolbar: {
              show: false
            }
          },
          stroke: {
            curve: 'smooth',
            width: 3
          },
          colors: ['#33ccff'],
          tooltip: {
            fixed: {
              enabled: false
            },
            x: {
              show: false
            },
            marker: {
              show: false
            }
          },
          grid: {
            show: false
          },
          xaxis: {
            labels: {
              show: false
            },
            axisBorder: {
              show: false
            },
            axisTicks: {
              show: false
            }
          },
          yaxis: {
            show: false
          }
        }
      };
    },

    methods:{
      getPriorityColor(priority) {
        switch(priority) {
          case 'Low': return 'rgba(5, 205, 153, 0.15)';
          case 'Medium': return 'rgba(255, 170, 0, 0.15)';
          case 'High': return 'rgba(255, 95, 87, 0.15)';
          case 'Very High': return 'rgba(100, 181, 246, 0.15)';
          default: return 'grey';
        }
      },
      getPriorityTextColor(priority) {
        switch(priority) {
          case 'Low': return 'success--text';
          case 'Medium': return 'warning--text';
          case 'High': return 'error--text';
          case 'Very High': return 'info--text';
          default: return '';
        }
      },
    }
  };
</script>

<style scoped>
.v-card {
  transition: transform 0.3s;
}
.v-card:hover {
  transform: translateY(-5px);
}

.month-selector {
  max-width: 150px;
}

.settings-btn {
  position: fixed;
  bottom: 30px;
  right: 30px;
}

.stats-list .v-card {
  transition: all 0.3s;
  border: 1px solid transparent;
}

.stats-list .v-card:hover {
  border-color: #e0e0e0;
  transform: translateY(-2px);
}

/* Estilos para las etiquetas de prioridad */
.v-chip.success--text {
  color: #05cd99 !important;
}
.v-chip.warning--text {
  color: #ffaa00 !important;
}
.v-chip.error--text {
  color: #ff5f57 !important;
}
.v-chip.info--text {
  color: #64b5f6 !important;
}

.fuenteTexto{
  font-family: 'Poppins', sans-serif !important;
}
</style>